import { BookingFeedbackComponent } from './booking-feedback/booking-feedback.component'
import { BookingFormComponent } from './booking-form/booking-form.component'
import { BookingModalComponent } from './booking-modal/booking-modal.component'
import { BookingModalLauncherComponent } from './modal-launcher/booking-modal-launcher.component'
import { BookingReminderComponent } from './booking-reminder/booking-reminder.component'
import { BookingSummaryComponent } from './booking-summary/booking-summary.component'
import { EventBookingPageComponent } from './event-booking-page/event-booking-page.component'
import { ModifyBookingComponent } from './modify-booking/modify-booking.component'
import { MenuChoicesEditComponent } from './menu-choices-edit/menu-choices-edit.component'
import { canLeaveMenuChoices, CoverChoicesPageComponent } from './menu-choices-edit/cover-choices-page.component'
import { IndividualMenuChoicesComponent } from './individual-menu-choices/individual-menu-choices.component'
import { LandingPageHomeComponent } from './landing-page/components/home/home.component'
import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { VoucherModalComponent } from './voucher-modal/voucher-modal.component'
import {
    VoucherModalLauncherComponent
} from './modal-launcher/voucher-modal-launcher.component'
import {
    VoucherStorefrontComponent
} from './landing-page/components/voucher-storefront/voucher-storefront.component'
import { VenueBookingPolicyComponent } from './landing-page/components/venue-booking-policy/venue-booking-policy.component'

export const routes: Routes = [
    {
        path: 'discover/:venueSlug/booking-policy',
        pathMatch: 'full',
        component: VenueBookingPolicyComponent,
    },
    {
        path: 'discover/:venueSlug/vouchers',
        pathMatch: 'full',
        component: VoucherStorefrontComponent,
    },
    {
        path: 'discover/:venueSlug',
        pathMatch: 'full',
        component: LandingPageHomeComponent,
    },
    {
        path: 'organisation/:organisationId/business/:businessId/venue/:venueId',
        component: BookingFormComponent,
    },
    {
        path: 'organisation/:organisationId/business/:businessId/venue/:venueId/booking/:bookingId/modify',
        component: ModifyBookingComponent,
    },
    {
        path: 'organisation/:organisationId/business/:businessId/venue/:venueId/modal',
        component: BookingModalComponent,
    },
    {
        path: 'organisation/:organisationId/business/:businessId/venue/:venueId/event',
        component: EventBookingPageComponent,
    },
    {
        path: 'organisation/:organisationId/business/:businessId/venue/:venueId/voucher/:voucherId/modal',
        component: VoucherModalComponent,
    },
    {
        path: 'booking/:bookingId/reminder/:reminderId',
        component: BookingReminderComponent,
    },
    {
        path: 'booking/:bookingId/feedback-request/:feedbackRequestId',
        component: BookingFeedbackComponent,
    },
    {
        path: 'booking/:bookingId',
        component: BookingSummaryComponent,
    },
    {
        path: 'booking/:bookingId/menu/edit/:coverIndex',
        component: CoverChoicesPageComponent,
        canDeactivate: [canLeaveMenuChoices],
        title: 'Choose your courses',
    },
    {
        path: 'booking/:bookingId/menu/individual/choices',
        component: CoverChoicesPageComponent,
        canDeactivate: [canLeaveMenuChoices],
        data: { individual: true },
        title: 'Choose your courses',
    },
    {
        path: 'booking/:bookingId/menu/edit',
        component: MenuChoicesEditComponent,
        title: 'Menu choices',
    },
    {
        path: 'booking/:bookingId/menu/individual',
        component: IndividualMenuChoicesComponent,
        title: 'Menu choices',
    },
    {
        path: 'organisation/:organisationId/business/:businessId/venue/:venueId/launcher',
        component: BookingModalLauncherComponent,
    },
    {
        path: 'organisation/:organisationId/business/:businessId/venue/:venueId/voucher/:voucherId/launcher',
        component: VoucherModalLauncherComponent,
    },
    {
        path: ':venueId',
        pathMatch: 'full',
        component: LandingPageHomeComponent,
    },
]

@NgModule({
    imports: [
        RouterModule.forRoot(
            routes, {
                bindToComponentInputs: true,
                canceledNavigationResolution: 'computed',
            }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule { }
